const _throttle = require('lodash.throttle');
window.addEventListener('load', function () {
    const testimonialPanels = document.querySelectorAll('.testimonial-panel'); // Handle multiple panels

    testimonialPanels.forEach((testimonialPanel) => {
        const testimonialFader = testimonialPanel.querySelector('div[data-testimonial-fader]');
        let fadeIntervalId; // Store interval ID so we can clear it on resize
        const fadeInterval = 8500; // 8.5 seconds

        if (testimonialFader) {
            function adjustHeightAndFade() {
                const children = Array.from(testimonialFader.children);
                // Set the height of the parent container to the height of the tallest child
                const maxHeight = Math.max(...children.map(child => child.offsetHeight));
                testimonialFader.style.height = `${maxHeight}px`;

                // Find currently active child or default to the first
                let currentIndex = children.findIndex(child => child.getAttribute('data-active') === 'true');
                if (currentIndex === -1) currentIndex = 0; // Default to first child if none is active

                // Clear any previous intervals to avoid overlap
                if (fadeIntervalId) clearInterval(fadeIntervalId);

                // Function to handle the fade logic
                function fadeChildren() {
                    children.forEach((child, index) => {
                        if (index === currentIndex) {
                            child.setAttribute('data-active', 'true');
                        } else {
                            child.setAttribute('data-active', 'false');
                        }
                    });
                    // Update the index for the next child in the cycle
                    currentIndex = (currentIndex + 1) % children.length;
                }

                // Apply initial fade and start the interval
                fadeChildren(); // Initial call
                fadeIntervalId = setInterval(fadeChildren, fadeInterval);
            }

            // Throttle the resize handler to avoid excessive recalculations
            const handleResize = _throttle(() => {
                adjustHeightAndFade();
            }, 200);

            // Initial setup on page load
            adjustHeightAndFade();

            // Re-adjust on window resize
            window.addEventListener('resize', handleResize);
        }
    });
});
